import * as tslib_1 from "tslib";
import { MatDialogRef } from '@angular/material/dialog';
import { isNullOrEmpty } from '@awp/core/utils';
export function showConfirmationDialog(dialogService, config) {
    var panelClass = config.panelClass != null ? config.panelClass.split(' ').filter(function (p) { return !isNullOrEmpty(p); }) : [];
    var parentClass = config.parentClass != null ? config.parentClass.split(' ').filter(function (p) { return !isNullOrEmpty(p); }) : [];
    return dialogService.open(ConfirmDialogComponent, {
        data: tslib_1.__assign({}, config, { parentClass: parentClass, showCloseButton: config.showCloseButton }),
        disableClose: !config.showCloseButton,
        panelClass: tslib_1.__spread(['ap-dialog', 'ap-confirmation-dialog'], panelClass)
    });
}
var ConfirmDialogComponent = /** @class */ (function () {
    function ConfirmDialogComponent(data) {
        this.data = data;
        this.showCloseButton = true;
        this.showCloseButton = data.showCloseButton == null ? true : data.showCloseButton;
    }
    return ConfirmDialogComponent;
}());
export { ConfirmDialogComponent };
